import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styled from 'styled-components';
import { RegisterForm } from '../../organisms';
import { authService } from '../../../services/authService';
import { userService } from '../../../services/userService';
import { useAuthStore } from '../../../store/authStore';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const Wrapper = styled.div`
  max-width: 400px;
  width: 100%;
`;

const MessageBox = styled.div`
  margin-top: 16px;
  padding: 12px;
  border-radius: 4px;
  text-align: center;
  max-width: 400px;
`;

const ErrorMessage = styled(MessageBox)`
  background-color: #fee;
  border: 1px solid #fcc;
  color: #c33;
`;

const SuccessMessage = styled(MessageBox)`
  background-color: #efe;
  border: 1px solid #cfc;
  color: #3c3;
`;

const LoginLink = styled(MessageBox)`
  background-color: white;
  border: 1px solid #ddd;
  color: #666;

  a {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const RegisterPage = () => {
  const navigate = useNavigate();
  const setUser = useAuthStore(state => state.setUser);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRegister = async (formData) => {
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // 1. Firebase Authentication에 회원가입
      const user = await authService.register(formData.email, formData.password);

      // 2. Firestore users 컬렉션에 사용자 정보 저장
      const userProfile = {
        uid: user.uid,
        email: formData.email,
        name: formData.name,
        phone: formData.phone,
        type: formData.type,
      };
      await userService.createUserDocument(user.uid, userProfile);

      // 3. 전역 상태에 사용자 정보 저장
      setUser(user, userProfile);

      // 4. 성공 메시지 표시
      setSuccess('회원가입이 완료되었습니다! 대시보드로 이동합니다...');

      // 5. 2초 후 대시보드로 이동
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);

    } catch (err) {
      console.error('Registration error:', err);

      // Firebase 에러 메시지 처리
      let errorMessage = '회원가입에 실패했습니다. ';

      if (err.code === 'auth/email-already-in-use') {
        errorMessage += '이미 사용 중인 이메일입니다.';
      } else if (err.code === 'auth/invalid-email') {
        errorMessage += '유효하지 않은 이메일 형식입니다.';
      } else if (err.code === 'auth/weak-password') {
        errorMessage += '비밀번호가 너무 약합니다. 최소 6자 이상 입력해주세요.';
      } else {
        errorMessage += err.message;
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Wrapper>
        <RegisterForm onSubmit={handleRegister} disabled={loading} />
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {success && <SuccessMessage>{success}</SuccessMessage>}
        <LoginLink>
          이미 계정이 있으신가요? <Link to="/login">로그인하기</Link>
        </LoginLink>
      </Wrapper>
    </Container>
  );
};

export default RegisterPage;
